import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useError } from '../contexts/ErrorContext';

/**
 * Custom hook to handle JWT expiration notifications
 * This hook should be used in components that need to show user-friendly
 * notifications when JWT expires
 */
export const useJwtExpiration = () => {
  const { wasAutoLoggedOut, clearAutoLogoutFlag } = useAuth();
  const { showWarning } = useError();

  useEffect(() => {
    if (wasAutoLoggedOut) {
      // Show a user-friendly notification
      showWarning('Your session has expired. Please log in again.');
      
      // Clear the flag after showing the notification
      clearAutoLogoutFlag();
      
      // Redirect to login page after a short delay
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    }
  }, [wasAutoLoggedOut, clearAutoLogoutFlag, showWarning]);

  return {
    wasAutoLoggedOut,
    clearAutoLogoutFlag
  };
};
